module.exports = __webpack_public_path__ + "img/bannerBook.08c3b319.png";